import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
    const year = new Date().getFullYear();

    return (
        <main className="min-h-screen bg-brand-bg text-white">
            <header className="border-b border-white/10 bg-[#0B0E14CC] backdrop-blur supports-[backdrop-filter]:bg-[#0B0E14CC]">
                <div className="mx-auto max-w-4xl px-6 py-4 flex items-center justify-between">
                    <h1 className="text-lg font-semibold">Política de Privacidade</h1>
                    <Link className="text-sm text-brand-muted hover:text-white transition" to="/">
                        ← Voltar
                    </Link>
                </div>
            </header>

            <section className="mx-auto max-w-4xl px-6 py-10">
                <p className="text-sm text-brand-muted mb-8">
                    Última atualização: {new Date().toLocaleDateString('pt-BR')}
                </p>

                <div className="space-y-8 text-brand-muted leading-relaxed">

                    <p>
                        A <strong className="text-white">Antares Tecnologia GTA</strong> (CNPJ 18.987.440/0001-40) é especializada
                        em automação via WhatsApp Business API, soluções SaaS e integrações com Twilio e 360dialog.
                        Esta Política descreve como coletamos, utilizamos e protegemos seus dados.
                    </p>

                    <div>
                        <h2 className="text-white font-semibold text-lg mb-3">1. Dados que coletamos</h2>
                        <ul className="list-disc pl-6 space-y-1">
                            <li>Nome completo e contato (e-mail, telefone/WhatsApp)</li>
                            <li>Mensagens com nossos chatbots e assistentes virtuais</li>
                            <li>Informações sobre sua empresa (segmento, necessidades)</li>
                            <li>Dados de navegação (cookies, IP, páginas visitadas)</li>
                            <li>Dados de formulários de contato ou demonstração</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="text-white font-semibold text-lg mb-3">2. Como utilizamos</h2>
                        <ul className="list-disc pl-6 space-y-1">
                            <li>Responder solicitações e pedidos de demonstração</li>
                            <li>Operar produtos SaaS (ZapBeauty, CarimbaNoZap)</li>
                            <li>Enviar comunicações de suporte e atualizações</li>
                            <li>Cumprir obrigações legais e regulatórias</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="text-white font-semibold text-lg mb-3">3. WhatsApp Business API</h2>
                        <p>
                            Utilizamos a <strong className="text-white">API oficial</strong> (Meta) via Twilio e 360dialog.
                            Ao interagir via WhatsApp, você também está sujeito à{' '}
                            <a href="https://www.whatsapp.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer"
                                className="text-blue-400 underline hover:text-blue-300">Política de Privacidade da Meta</a>.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-white font-semibold text-lg mb-3">4. Compartilhamento</h2>
                        <p>Não vendemos seus dados. Compartilhamos apenas com provedores de infraestrutura
                            (Twilio, 360dialog) e autoridades quando exigido por lei.</p>
                    </div>

                    <div>
                        <h2 className="text-white font-semibold text-lg mb-3">5. Retenção</h2>
                        <p>Mantemos seus dados pelo tempo necessário ao serviço ou exigido por lei.
                            Você pode solicitar exclusão a qualquer momento.</p>
                    </div>

                    <div>
                        <h2 className="text-white font-semibold text-lg mb-3">6. Segurança</h2>
                        <p>Adotamos HTTPS/TLS e medidas técnicas para proteger seus dados contra acesso não autorizado.</p>
                    </div>

                    <div>
                        <h2 className="text-white font-semibold text-lg mb-3">7. Seus direitos (LGPD)</h2>
                        <p>Conforme a <strong className="text-white">Lei nº 13.709/2018</strong>: confirmar tratamento,
                            acessar, corrigir, solicitar exclusão/anonimização e revogar consentimento.</p>
                    </div>

                    <div>
                        <h2 className="text-white font-semibold text-lg mb-3">8. Cookies</h2>
                        <p>Usamos cookies técnicos e analytics. Você pode desabilitá-los no navegador.</p>
                    </div>

                    <div>
                        <h2 className="text-white font-semibold text-lg mb-3">9. Contato</h2>
                        <ul className="space-y-1">
                            <li><strong className="text-white">Razão Social:</strong> Thiago Xavier Pacheco</li>
                            <li><strong className="text-white">CNPJ:</strong> 18.987.440/0001-40</li>
                            <li><strong className="text-white">E-mail:</strong>{' '}
                                <a href="mailto:antarestecnologiagta@gmail.com" className="text-blue-400 underline hover:text-blue-300">
                                    antarestecnologiagta@gmail.com</a></li>
                            <li><strong className="text-white">WhatsApp:</strong>{' '}
                                <a href="https://wa.me/5511930628624" className="text-blue-400 underline hover:text-blue-300">
                                    +55 (11) 93062-8624</a></li>
                        </ul>
                    </div>

                    <div className="border-t border-white/10 pt-6">
                        <p className="text-xs text-center">
                            © {year} Antares Tecnologia GTA. Todos os direitos reservados. — CNPJ 18.987.440/0001-40
                        </p>
                    </div>

                </div>
            </section>
        </main>
    );
}

export { };

